export const resultPageButtons = ['Reports', 'Taxes', 'Overall'];
